import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonTable from './SkeletonTable'

export type SkeletonStackedTablesProps = {
    sections?: number
    rows?: number
    columns?: number
}

export default function SkeletonStackedTables(props: Readonly<SkeletonStackedTablesProps>) {
    const { sections = 2, rows = 8, columns = 7 } = props

    return (
        <Grid container spacing={2} size={12}>
            {Array.from({ length: sections }, (_, index) => (
                <Grid key={index} size={12}>
                    <Paper sx={{ p: 2 }}>
                        <Stack
                            direction="row"
                            sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
                        >
                            <Skeleton variant="text" width={180} sx={{ fontSize: '1.5rem' }} />
                            <Skeleton variant="circular" width={22} height={22} />
                        </Stack>
                        <SkeletonTable rows={rows} columns={columns} showToolbar={false} />
                        <Stack direction="row" sx={{ justifyContent: 'flex-end', pt: 1.5 }}>
                            <Skeleton variant="text" width={120} />
                        </Stack>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    )
}
